import React from 'react';
import { ListItemHeader } from 'app/area/shared/list-components/list-item-header';
import { ExternalUrlTileHeader } from './external-url-tile-header';
import { ExternalUrlItem } from 'app/area/external-url-groups/form/types-store';
import { ExternalUrlGroupsTranslation } from 'app/area/external-url-groups/constants';
import styles from './external-url-drag-preview.scss';

export const renderExternalUrlDragPreview =
  (translation: ExternalUrlGroupsTranslation) =>
    (externalUrlItem: ExternalUrlItem) =>
      !!externalUrlItem && <div className={styles.dragPreview}>
        <ListItemHeader>
          <ExternalUrlTileHeader
            externalUrlItem={externalUrlItem}
            canDrag={true}
            disabledLabel={translation.disabled} />
        </ListItemHeader>
      </div>;
